import type { VisibilityState } from '@tanstack/react-table';
import type { DRIValueType, IndividualDetailsRow } from '../../../types/driInsights';
import { driValueForProductDetail } from '../../../utils/driInsightsUtils';
import { exportCsvWithVisibleColumns } from '../../../utils/csvExport';

export function exportIndividualDetailsGridToCsv(options: {
  rows: IndividualDetailsRow[];
  columnVisibility: VisibilityState;
  columnIdsInOrder: readonly string[];
  columnLabels: Record<string, string>;
  gridCellValueType: DRIValueType;
  filenameBase?: string;
}): void {
  const { rows, columnVisibility, columnIdsInOrder, columnLabels, gridCellValueType, filenameBase = 'dri-individual-details' } =
    options;

  const getCellText = (row: IndividualDetailsRow, columnId: string): string => {
    if (columnId === 'individual_email') {
      return row.employee.member_email ?? '';
    }
    if (columnId.startsWith('product_')) {
      const productName = columnId.slice('product_'.length);
      const prodData = row.products[productName];
      if (!prodData) return '-';
      const v = driValueForProductDetail(prodData, gridCellValueType);
      return Number.isFinite(v) ? v.toFixed(2) : '-';
    }
    return '';
  };

  exportCsvWithVisibleColumns({
    rows,
    columnVisibility,
    columnIdsInOrder,
    columnLabels,
    getCellText,
    filenameBase,
  });
}
